import { createSlice } from "@reduxjs/toolkit";
import { esCO } from "../languages/esCO";
const initialState = {
    labels: esCO,
    currentLanguage: 'es-CO'
};
export const languageSlice = createSlice({
    name: 'language',
    initialState: initialState,
    reducers: {
        setLanguage: (state, action) => {
            state.currentLanguage = action.payload || initialState.currentLanguage;
        },
    }
});
